(() => {
  const dialog = document.querySelector('[data-mc-email-popup]');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const storageKey = 'mcarbonique-newsletter-until-v1';
  let previousFocus;
  let timer;
  let suppressed = dialog.dataset.subscribed === 'true';
  const remember = (days) => {
    suppressed = true;
    try { localStorage.setItem(storageKey, String(Date.now() + days * 86400000)); } catch (_) { /* Signup remains usable when storage is unavailable. */ }
  };
  try { suppressed = suppressed || Number(localStorage.getItem(storageKey)) > Date.now(); } catch (_) { /* No persistent storage. */ }
  const open = () => {
    clearTimeout(timer);
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
  };
  const dismiss = () => { remember(30); dialog.close(); };
  dialog.querySelectorAll('[data-newsletter-dismiss]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dismiss();
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open-newsletter]')) { event.preventDefault(); open(); }
  });
  if (dialog.querySelector('[data-newsletter-success]')) { remember(365); open(); }
  else if (dialog.querySelector('[data-newsletter-error]')) open();
  else if (!suppressed && !window.Shopify?.designMode) {
    timer = setTimeout(() => { if (!suppressed) open(); }, Number(dialog.dataset.delay) || 8000);
  }
})();
